// extracted by mini-css-extract-plugin
export default {"root":"RefereeReport_root__a8RHm","topRef":"RefereeReport_topRef__ERmWF","topButton":"RefereeReport_topButton__c5hAI"};